export function bindFunctions(object: any, prefix: string = '_') {
  const keys = Object.getOwnPropertyNames(Object.getPrototypeOf(object))

  /* tslint:disable:forin */
  for (const k in keys) {
    const key = object[keys[k]]
    if (typeof key === 'function' && keys[k].startsWith(prefix)) {
      object[keys[k]] = object[keys[k]].bind(object)
    }
  }
  /* tslint:enable:forin */
}
